import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-navlist', 'MY_SHORTCUTS', 'Мои закладки');
Labels.set('ui-navlist', 'REMOVE_SHORTCUT', 'Удалить закладку');
Labels.set('ui-navlist', 'ADD_SHORTCUT', 'Добавить в закладки');
Labels.set('ui-navlist', 'EDIT_SHORTCUTS', 'Изменить закладки');
Labels.set('ui-navlist', 'FINISH_EDITING', 'Закрыть изменения');
Labels.set('ui-navlist', 'BACK', 'Назад');
